import { TemplateMetadataSTORE } from "../../../../../../store/templateMetadata/types";
import { Colors } from "../../../../../../globalTypes/theme";
import { KpiMetadata } from "../../../../../../requests/templates/types";

export const getKpiNotificationColor = (
  kpiMetadata: KpiMetadata,
  colors: Colors,
  notificationCount: number
) => {
  const { criticalThreshold, importantThreshold } = kpiMetadata;

  switch (true) {
    case criticalThreshold && notificationCount >= criticalThreshold:
      return colors.kpi.critical;
    case importantThreshold && notificationCount >= importantThreshold:
      return colors.kpi.important;
    default:
      return colors.kpi.ok;
  }
};

export const getNotificationColor = (
  kpiMetadata: KpiMetadata | null,
  colors: Colors,
  notificationCount: number
) => {
  if (!kpiMetadata || !kpiMetadata.displayAsKpi) return colors.delete;

  return getKpiNotificationColor(kpiMetadata, colors, notificationCount);
};
